// Definitions related to the libraries documentation system

export const faustDocURL = "https://faustlibraries.grame.fr/libs";

export const docSections: { [key: string]: string } = {
    aa: "aanl",
    an: "analyzers",
    ba: "basics",
    co: "compressors",
    de: "delays",
    dm: "demos",
    dx: "dx7",
    en: "envelopes",
    fd: "fds",
    fi: "filters",
    ho: "hoa",
    it: "interpolators",
    ma: "maths",
    mi: "mi",
    ef: "misceffects",
    os: "oscillators",
    no: "noises",
    pf: "phaflangers",
    pm: "physmodels",
    qu: "quantizers",
    rm: "reducemaps",
    re: "reverbs",
    ro: "routes",
    si: "signals",
    so: "soundfiles",
    sp: "spats",
    sy: "synths",
    ve: "vaeffects",
    vl: "version",
    wa: "webaudio",
    wd: "wdmodels"
};
